import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { TagComponent } from '../types/Components';

/**
 * A tag component to identify the player entity.
 */
class PlayerControlled extends Component implements TagComponent {}

export default simpleComponent(PlayerControlled);
